export function isAuthenticated() {
    return !!localStorage.getItem("access_token");
}

export function token() {
    if (!isAuthenticated()) return null;
    return localStorage.getItem("access_token");
}